// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hyBS","col":"styles_col__FnpZJ"};